module.exports = __webpack_public_path__ + "static/escrow-68153a2ce14aed3617f487e548cb6991.png";